import React, { Component } from "react";
import styles from "./index.module.scss";
import Slider from "react-slick";
import axios from "@/util/axios";
import { api } from "@/routes/api";
import { connect } from 'react-redux';
import { changeLoading } from '@/redux/base.redux';
const { getBannerList } = api;

@connect(
  null,
  { changeLoading }
)
class Index extends Component {
  state = {
    pcBannerList: [],
    mobileBannerList: [],
  };

  async componentDidMount() {
    this.props.changeLoading(true);
    const res = await axios.post(getBannerList, { use_type: 1 }); // 1-pc 2-手机
    const res2 = await axios.post(getBannerList, { use_type: 2 });
    if (res.code === 0) {
      this.setState({ pcBannerList: res.data, ambulance: res.ambulance });
    }
    if (res2.code === 0) {
      this.setState({ mobileBannerList: res2.data });
    }
    setTimeout(() => this.props.changeLoading(false), 500);
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    const { pcBannerList, mobileBannerList, ambulance } = this.state;
    return (
      <div className="banner">
        <div className="pc_banner">
          <Slider {...settings}>
            {pcBannerList.map(item => (
              <div>
                <div className={`${styles.banner}`}>
                  {
                    item.type === 1 ? (
                      <img src={ambulance + item.photo} alt="" />
                    ) : (
                        <a href={item.url}><img src={ambulance + item.photo} alt="" /></a>
                      )
                  }
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="mobile_banner">
          <Slider {...settings}>
            {mobileBannerList.map(item => (
              <div>
                <div className={`${styles.banner}`}>
                  {
                    item.type === 1 ? (
                      <img src={ambulance + item.photo} alt="" />
                    ) : (
                        <a href={item.url}><img src={ambulance + item.photo} alt="" /></a>
                      )
                  }
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default Index;
